<template>
  <article class="EventCard">
        <a class="EventCard-inner" :href="href">
            <div class="EventCard-imgContainer">
              <image-vue class="EventCard-img" :width="352" :height="198" :imgId="imgId" :alt="imgAlt" />
            </div>
            <h3 class="EventCard-title">{{title}}</h3>
            <time class="EventCard-date">{{formattedDate}}</time> 
            <p class="EventCard-desc" v-html="shortDesc"></p>
            <div v-if="price" class="EventCard-price"><strong>From £{{price}} {{ticketsFromPostfix}}</strong></div>
        </a>
    </article>
</template>

<script>
import Image from '../UI/Image.vue';
import {formatInterval} from "../../../../utils/dates";

export default {
  components: { 'image-vue': Image },
  props: {
    href: String,
    imgId: Number,
    imgAlt: String,
    startDate: String,
    endDate: String,
    title: String,
    desc: String,
    shortDesc: String,
    price: String,
    ticketsFromPostfix: String
  },
  computed: {
    formattedDate() {
      return formatInterval(this.startDate, this.endDate);
    }
  }
}
</script>